exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-container[data-v-35bb8e84] {\n  width: 35px;\n  float: left;\n}\n.icon-location[data-v-35bb8e84] {\n  cursor: pointer;\n}\n.address-text-tooltip[data-v-35bb8e84] {\n  text-align: left;\n}\n.md-tooltip[data-v-35bb8e84] {\n  min-width: 300px !important;\n}\n", ""]);

// exports
